document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('[data-store-availability-container]');
    if (!container) return;
  
    function updatePickupAvailability(variantId) {
      if (!variantId) return;
  
      fetch(`${window.Shopify.routes.root}variants/${variantId}/?section_id=pickup-availability`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const section = doc.querySelector('.shopify-section');
  
          container.innerHTML = '';
          if (section) container.appendChild(section);
        })
        .catch(err => console.error('Pickup availability error:', err));
    }
  
    // Initial load
    const productForm = document.querySelector('form[action="/cart/add"]');
    let currentVariantId = productForm?.querySelector('[name="id"]')?.value;
    if (currentVariantId) updatePickupAvailability(currentVariantId);
  
    // Listen for any change on inputs inside the form (select, radio, etc.)
    productForm?.addEventListener('change', (event) => {
      const variantInput = productForm.querySelector('[name="id"]');
      if (variantInput) {
        updatePickupAvailability(variantInput.value);
      }
    });
  
    // Optional: listen for OS2.0 variant events (Dawn, etc.)
    document.addEventListener('variant:changed', (event) => {
      const variantId = event.detail.variant?.id;
      if (variantId) updatePickupAvailability(variantId);
    });

    // open modal - use event delegation since content is loaded dynamically
    container.addEventListener('click', (event) => {
      if (event.target.closest('.pickup-availability-information__button')) {
        event.preventDefault();
        console.log('clicked');
        document.querySelector('.pickup-availability-information__button').classList.toggle('is-clicked');
        document.querySelector('.pickup-availabilities-modal').classList.toggle('is-open');
      }
    });
    // Close modal when .pickup-availabilities-modal__close is clicked
    container.addEventListener('click', (event) => {
      const closeBtn = event.target.closest('.pickup-availabilities-modal__close');
      if (closeBtn) {
        event.preventDefault();
        document.querySelector('.pickup-availability-information__button')?.classList.remove('is-clicked');
        document.querySelector('.pickup-availabilities-modal')?.classList.remove('is-open');
      }
    });
  });
  
  // Product Option Buttons Handler
  $(document).ready(function() {
    var $originalSelect = $('select.original-selector');
    
    $('.option-buttons').each(function() {
      var $container = $(this);
      var $buttons = $container.find('.option-button');
      
      $buttons.on('click', function(e) {
        e.preventDefault();
        
        // Update active state
        $buttons.removeClass('active');
        $(this).addClass('active');
        
        // Get all selected option values
        var selectedOptions = [];
        $('.option-buttons').each(function() {
          var activeButton = $(this).find('.option-button.active');
          if (activeButton.length) {
            selectedOptions.push(activeButton.data('value'));
          }
        });
        
        // Find matching variant in original selector
        var variantTitle = selectedOptions.join(' / ');
        
        $originalSelect.find('option').each(function() {
          // Trim whitespace from option text for comparison
          var optionText = $(this).text().trim();
          if (optionText === variantTitle) {
            $(this).prop('selected', true);
            
            // Trigger both jQuery and native change events
            $originalSelect.trigger('change');
            
            // Trigger native event for vanilla JS listeners (pickup availability)
            var nativeSelect = $originalSelect[0];
            if (nativeSelect) {
              var event = new Event('change', { bubbles: true });
              nativeSelect.dispatchEvent(event);
            }
            
            return false; // break loop
          }
        });
      });
    });

    //product accordion
        $('.accordion-gh').on('click', '.heading', function(e) {
          console.log('clicked');
            $(this).toggleClass('active');
            $(this).next('.content').toggleClass('active');
        });

    // size guide modal
    // Size guide modal
    const sizeGuideModal = document.querySelector('.size-guide-modal');
    
    if (sizeGuideModal) {
      // Open modal
      $('.js-size-guide-trigger').on('click', function(e) {
        e.preventDefault();
        sizeGuideModal.showModal();
        sizeGuideModal.classList.add('modal-visible');
      });
      
      // Close modal when close button clicked
      $('.js-size-guide-close').on('click', function() {
        sizeGuideModal.close();
        sizeGuideModal.classList.remove('modal-visible');
      });
      
      // Close modal when clicking backdrop (outside content)
      sizeGuideModal.addEventListener('click', function(e) {
        if (e.target === sizeGuideModal) {
          sizeGuideModal.close();
          sizeGuideModal.classList.remove('modal-visible');
        }
      });
    }

    

  });
  